module.exports = __webpack_public_path__ + "static/insights_report-3a5bbe9f041a3f6c981c84c93cfc1018.jpg";